// eslint-disable-next-line import/prefer-default-export
export var ALLOWED_CHARACTERS = /[^0-9]/g;